import { mediaQuery } from 'common/theme/media';
import styled, { css } from 'styled-components';

export const Mobile = css``;
export const Tablet = css``;

export const PageStyled = styled.div`
    background-color: #3f90c8;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 485px;
    padding-top: 64px;
    position: relative;

    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    flex-direction: column;

    &::before {
        content: '';
        background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 8.25%,
            rgba(3, 13, 22, 0.272957) 54.13%,
            rgba(5, 20, 34, 0.43) 100%
        );
        width: 100%;
        height: 250px;
        position: absolute;
        bottom: 0;
        z-index: 0;
    }

    .container {
        z-index: 1;
        position: relative;
        flex: 1;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        flex-direction: column;
        padding-bottom: 25px;
        .text {
            text-align: center;
            padding: 20px 0;
            .title {
                margin-top: 56px;
                padding-top: 4px;
                color: #ffffff;
                text-shadow: 2px 2px 20px rgba(0, 0, 0, 0.3);
                font-weight: 400 !important;
                line-height: 50px;
                font-size: 36px !important;
                position: relative;
                &::before {
                    content: '';
                    width: 26px;
                    height: 6px;
                    background-color: var(--mui-palette-secondary-main);
                    border-radius: 23px;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    margin: auto;
                }
                b {
                    font-weight: 700;
                }
            }
        }
        .search {
        }
    }

    ${mediaQuery.lessThan('xltablet')`${Tablet}`}
    ${mediaQuery.lessThan('mobile')`${Mobile}`}
    
    @media only screen and (max-width: 600px) {
        min-height: 400px !important;
        margin-bottom: 310px;
        .container {
            position: relative;
            .text {
                .title {
                    margin-top: 36px;
                    font-size: 20px;
                    line-height: 34px;
                    padding-top: 20px;
                }
                margin-bottom: 50px;
            }
        }
        .search {
            position: relative;
            margin-bottom: -340px;
            left: 0;
            padding: 15px;
            border-radius: 12px;
            background-color: #ffffff;
            color: #000;
        }
    }
`;
